export default __webpack_public_path__ + "img/accha/accha3_480.jpg";